import { persistentStore, memStore } from 'services/storage';
import { copyProps, registerFCMToken } from 'util/misc';
import { apiPost, apiGet } from 'services/api';
import {
  sendAmplitudeData,
  setAmplitudeUserId,
  setAmplitudeUserProperties,
} from 'util/amplitude';
import { disconnectChat } from './chat';

export async function login({ phone, otp, remember }) {
  const user = await apiPost(`/user/login`, {
    body: { phone, otp: otp },
  });
  if (user.error) {
    return user;
  } else {
    setLoggedInUser(user.data, remember);
    setAmplitudeUserId(user.data['session-token']);
    setAmplitudeUserProperties(user.data.userData);
    registerFCMToken(user);
    return extractUserData(user.data);
  }
}

export async function requestOTP(phone) {
  const response = await apiPost(`/user/otp/generate`, {
    body: { phone },
  });
  return response;
}

export async function goto({ magicLinkToken, query }) {
  const user = await apiGet(`/goto/${magicLinkToken}${query}`);
  setLoggedInUser(user.data);
  setAmplitudeUserId(user.data['session-token']);
  const userData = extractUserData(user.data);
  return {
    userData,
    link: user.data.link,
    pageType: user.data.pageType,
  };
}

export async function logout() {
  const userData = persistentStore.get('user');
  if (userData && userData.callLogout) {
    try {
      await apiPost('/logout', {});
    } catch (error) {
      console.log(error);
    }
  }
  memStore.clear();
  persistentStore.remove('user');
  disconnectChat();
  sendAmplitudeData('Qiscus disconnection called', {
    qiscusDisconnected: true,
  });
  return;
}

export async function getLoggedInUser() {
  return extractUserData(persistentStore.get('user'));
}

function extractUserData(user) {
  if (user) {
    const roles = (user.userData.roles || '').split(',');
    memStore.set('userRoles', roles);
    memStore.set('apiAuthHeaders', copyProps(['session-token'], user));

    const chatProps = Object.keys(user).filter((prop) => prop.match(/^chat/));
    const chatConfig = copyProps(chatProps, user);
    chatConfig &&
      memStore.set('chatConfig', {
        ...chatConfig,
        userId: user.userData.userId,
      });

    return {
      ...user.userData,
      roles,
    };
  }
}

function setLoggedInUser(user, remember = true) {
  remember && persistentStore.set('user', user);
}
